import { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './PostsGrid.module.css';
import cn from 'classnames';

type Props = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const PostsGrid = ({ children, className, ...props }: Props) => {
    return (
        <div className={cn(styles.grid, className)} {...props}>
            {children}
        </div>
    );
};

export default PostsGrid;
